import { render } from "./DeviceDetails.vue?vue&type=template&id=2b9b18e9&scoped=true&ts=true"
import script from "./DeviceDetails.vue?vue&type=script&lang=ts"
export * from "./DeviceDetails.vue?vue&type=script&lang=ts"

import "./DeviceDetails.vue?vue&type=style&index=0&id=2b9b18e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9b18e9"]])

export default __exports__